import type { Theme } from '../types/clock'

export const themes: Theme[] = [
  {
    id: 'chevaux',
    nom: 'Passion Chevaux',
    categorie: 'Animaux',
    image:
      'https://cdn.magicpatterns.com/uploads/57AQ5rLf5d42uh3WX7ZRto/brk-e5ad0644-a707-440d-b618-96eb1db701a9.png',
    description: 'Chevaux au pré, lumière de fin de journée.',
  },
  {
    id: 'chats',
    nom: 'Chatons à la fenêtre',
    categorie: 'Animaux',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2f58ea66-feb7-43f7-9b86-00bddd6ac933.jpg',
    description: 'Deux chatons et géraniums, ambiance cottage.',
  },
  {
    id: 'montagne',
    nom: 'Chalet en montagne',
    categorie: 'Paysages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bb718153-0fef-4ca4-a47b-2e63e2c049de.jpg',
    description: 'Lac alpin, sapins et sommets enneigés.',
  },
  {
    id: 'mer',
    nom: 'Phare et grand large',
    categorie: 'Paysages',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a66d0977-6f13-4fb0-b604-273de930f3a4.jpg',
    description: 'Côte bretonne au coucher du soleil.',
  },
  {
    id: 'fleurs',
    nom: 'Bouquet des champs',
    categorie: 'Fleurs',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0d76501b-2b4b-4379-b56f-57da7722bd55.jpg',
    description: 'Coquelicots, marguerites et lavande.',
  },
]

export const heroPhoto =
  'https://cdn.magicpatterns.com/patterns/generated-images/0464fcd0-02c7-4346-a55b-200374b40cd2.jpg'

export const categories = ['Tous', 'Animaux', 'Paysages', 'Fleurs']
